import { Component, h, Host, Prop } from '@stencil/core';

import wcShared from '@web-components/shared';

import { Store } from '../../../../../../../../utils/Stores/store';

@Component({
  tag: 'chat-message-ticket-component',
  styleUrl: 'chat-message-ticket-module.scss',
  shadow: true,
})
export class ModuleChatMessageTicket {
  @Prop() readonly message: IWCChatMessage;

  private mappingStatus(status: string) {
    if (status === 'closed') {
      return wcShared?.translate('Traite');
    } else {
      return wcShared?.translate('En cours de traitement');
    }
  }

  private mappingColor(status: string) {
    if (status === 'closed') {
      return '#3EBF4D';
    } else {
      return '#FF8500';
    }
  }

  render() {
    return (
      <Host>
        <div class="ticket-core-tickets">
          {(this.message?.action as IWCChatMessageValue[])?.map((ticket) => {
            return (
              <div
                class={{
                  'ticket-core-ticket': true,
                  'ticket-core-ticket--mobile': Store?.get('isMobile'),
                }}
              >
                <div class="title">
                  <span
                    class="title__round"
                    style={{ background: this.mappingColor(ticket?.status) }}
                  ></span>
                  <span
                    class="title__status"
                    style={{ color: this.mappingColor(ticket?.status) }}
                  >
                    {this.mappingStatus(ticket?.status)}
                  </span>
                </div>
                <div class="description">{ticket?.subject}</div>
                <div class="last-row">
                  <div class="date">
                    {wcShared?.store?.pipes?.formatDate(ticket?.updated, 'dd/MM/yyyy HH:mm')}
                  </div>
                  <div class="ticket-id">
                    #{(this.message?.action as IWCChatMessageValue[])[0].mask}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </Host>
    );
  }
}
